import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _ from "lodash";
import wlcBtnNext from "./components/wlc-btn-next.vue";
import TagList from "./components/TagList.vue";
import CategoryList from "./components/CategoryList.vue";
import FlowPool from "./components/FlowPool.vue";
import RejectModal from "@/views/community/components/RejectModal.vue";
import PostLog from "@/views/community/components/PostLog.vue";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
import { mapActions } from "vuex";
import { appendUrlParam } from "@/utils/url";
import wlcConversationList from "@/views/house/components/update/wlc-conversation-list.vue";
import { userRechargeType } from "@/utils/user";
var perceptionCode = {
  PHiuUt: "诈骗",
  orTPeJ: "中介/二房东"
};
export default {
  mixins: [userPopMixin],
  components: {
    wlcConversationList: wlcConversationList,
    wlcBtnNext: wlcBtnNext,
    TagList: TagList,
    CategoryList: CategoryList,
    FlowPool: FlowPool,
    RejectModal: RejectModal,
    PostLog: PostLog
  },
  name: "lifestyle-update",
  data: function data() {
    return {
      videoVisible: false,
      btnNextVisible: false,
      form: {
        image_urls: [],
        cover_url: "",
        location: "",
        title: "",
        content: "",
        tag: [],
        video_url: ""
      },
      userForm: {},
      originalUserForm: {},
      // 保存原始用户数据用于对比
      previewDialogVisible: false,
      imageRotateDialogVisible: false,
      imageRotateUrl: "",
      imageRotateKey: "",
      userTag: [],
      deviceRisk: {},
      tagList: [],
      postLog: [],
      loading: false,
      loadingLog: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            // 添加全局键盘事件监听
            document.addEventListener('keydown', _this.handleKeyDown);
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    // 移除全局键盘事件监听
    document.removeEventListener('keydown', this.handleKeyDown);
  },
  computed: {
    getPerceptionCodeName: function getPerceptionCodeName() {
      return perceptionCode[this.deviceRisk.perception_code] ? perceptionCode[this.deviceRisk.perception_code] : "";
    },
    showPrice: function showPrice() {
      var _this$form, _this$form2;
      return ((_this$form = this.form) === null || _this$form === void 0 ? void 0 : _this$form.source) === "used_legacy_full" || ((_this$form2 = this.form) === null || _this$form2 === void 0 ? void 0 : _this$form2.source) === "used_legacy_incremental";
    }
  },
  watch: {
    "$route.query.id": function $routeQueryId() {
      this.userTag = [];
      this.loading = true;
      this.getData();
      this.btnNextVisible = false;
      this.releaseCompleteState = false;
      var containerBody = document.getElementsByClassName("d2-container-full__body")[0];
      containerBody.scrollTop = 0;
    },
    previewDialogVisible: function previewDialogVisible() {
      var _this2 = this;
      this.$nextTick(function () {
        if (_this2.previewDialogVisible) {
          document.addEventListener("keydown", _this2.keydownEventHandle);
        } else {
          document.removeEventListener("keydown", _this2.keydownEventHandle);
        }
      });
    },
    "form.url": function formUrl() {
      if (this.form.url) {
        this.form.image_urls.push(this.form.url);
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/page", ["close"])), {}, {
    userRechargeType: userRechargeType,
    thumbnailUrl: function thumbnailUrl(url) {
      return url ? appendUrlParam(url, "imageView2/0/w/400/h/400") : "";
    },
    closeRotateDialog: function closeRotateDialog() {
      this.imageRotateDialogVisible = false;
    },
    saveRotateImgUrl: function saveRotateImgUrl(url) {
      this.form.image_urls.splice(this.imageRotateKey, 1, url);
      if (this.imageRotateUrl == this.form.cover_url) {
        this.form.cover_url = url;
      }
    },
    selectRotateImg: function selectRotateImg(key) {
      this.imageRotateKey = key || 0;
      this.imageRotateUrl = this.form.image_urls[this.imageRotateKey];
      this.imageRotateDialogVisible = true;
    },
    keydownEventHandle: function keydownEventHandle(event) {
      if (event.key === "ArrowLeft") {
        this.$refs.carousel.prev();
      }
      if (event.key === "ArrowRight") {
        this.$refs.carousel.next();
      }
    },
    previewImage: function previewImage(index) {
      var _this3 = this;
      this.previewDialogVisible = true;
      this.$nextTick(function () {
        setTimeout(function () {
          _this3.$refs.carousel.setActiveItem(index);
        });
      });
    },
    getUserDeviceRisk: function getUserDeviceRisk() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this4.$api.getUserDeviceRisk({
                user_id: _this4.form.user_id
              });
            case 1:
              res = _context2.v;
              _this4.deviceRisk = res.data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getUsersTagList: function getUsersTagList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this5.$api.getUsersTagList({
                top: 5,
                user_id: _this5.form.user_id
              });
            case 1:
              res = _context3.v;
              if (res.data[_this5.form.user_id]) {
                _this5.userTag = res.data[_this5.form.user_id];
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    reject: function reject(type) {
      this.audit(2, type);
    },
    /* 审核
    /** status 1 通过 0 拒绝
    /** type 操作状态 0 通过 1 仅拒绝 2-6拒绝通知类型
     */
    audit: function audit(status, type) {
      var _this6 = this;
      if (status === 1) {
        this.$confirm("\u662F\u5426\u901A\u8FC7?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                _this6.setAuditStatus(status, type);
              case 1:
                return _context4.a(2);
            }
          }, _callee4);
        })));
      } else {
        this.setAuditStatus(status, type);
      }
    },
    setAuditStatus: function setAuditStatus(status, type) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this7.form.audit_status = status;
              _context5.n = 1;
              return _this7.save("audit");
            case 1:
              _context5.n = 2;
              return _this7.$api.auditCommunity({
                id: _this7.$route.query.id,
                audit_status: status,
                reject_type: type
              });
            case 2:
              _this7.$message.success(status === 1 ? "已通过" : "已拒绝");
              // 操作上报
              _this7.$operationLog.push({
                code: status === 1 ? "pass" : "reject",
                userId: _this7.userForm.id,
                operationType: "community",
                detailBatchNo: _this7.$route.query.id
              });
              _this7.btnNextVisible = true;
            case 3:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    saveUserInfo: function saveUserInfo() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var updateData;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              // 只传递变动的字段
              updateData = {
                avatar: _this8.userForm.avatar,
                name: _this8.userForm.name,
                introduce: _this8.userForm.introduce,
                occupation: _this8.userForm.occupation
              }; // 判断 remark 是否变动
              if (_this8.userForm.remark !== _this8.originalUserForm.remark) {
                updateData.remark = _this8.userForm.remark;
              }
              _context6.n = 1;
              return _this8.$api.updateUser({
                userId: _this8.userForm.id,
                update: updateData
              });
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    getUserInfo: function getUserInfo(id) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return _this9.$api.getUserBaseInfo({
                id: id
              });
            case 1:
              res = _context7.v;
              _this9.userForm = res.data;
              // 保存原始数据用于对比
              _this9.originalUserForm = {
                remark: res.data.remark
              };
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    getUserTagList: function getUserTagList() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return _this0.$api.getUserTagList({});
            case 1:
              res = _context8.v;
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    getData: function getData() {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var _res$data, _this1$form, _this1$form2;
        var res;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _this1.loading = true;
              _context9.n = 1;
              return _this1.$api.getCommunityDetail(_this1.$route.query.id);
            case 1:
              res = _context9.v;
              _this1.getUserInfo(res.data.user_id);
              _this1.getUserPostLog(res.data.user_id);
              res.data.tag = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.tag_ids) || [];
              _this1.form = res.data;
              _this1.getUsersTagList();
              _this1.getUserDeviceRisk();
              _this1.loading = false;
              _this1.combinedData(_this1.form.text_category_names, _this1.form.text_category_ids, "textCategoryList");
              _this1.combinedData(_this1.form.media_category_names, _this1.form.media_category_ids, "mediaCategoryList");
              _this1.combinedData(_this1.form.admin_category_names, _this1.form.admin_category_ids, "adminCategoryList");
              _this1.$set(_this1.form, "categoryList", _.unionWith([].concat(_toConsumableArray(((_this1$form = _this1.form) === null || _this1$form === void 0 ? void 0 : _this1$form.textCategoryList) || []), _toConsumableArray(((_this1$form2 = _this1.form) === null || _this1$form2 === void 0 ? void 0 : _this1$form2.mediaCategoryList) || [])), _.isEqual));
              _this1.$nextTick(function () {
                var _this1$form3, _this1$form4;
                _this1.$refs.tagList.setTagList([].concat(_toConsumableArray(((_this1$form3 = _this1.form) === null || _this1$form3 === void 0 ? void 0 : _this1$form3.admin_tags) || []), _toConsumableArray(((_this1$form4 = _this1.form) === null || _this1$form4 === void 0 ? void 0 : _this1$form4.model_tags) || [])));
              });
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    //拼装数据 标签、分类等
    combinedData: function combinedData(names, ids, key) {
      if (names && ids) {
        var arr = names.map(function (item, index) {
          return {
            name: item,
            id: ids[index]
          };
        });
        key && this.$set(this.form, key, arr);
      }
    },
    //解构数据 标签、分类等
    deconstructionData: function deconstructionData(namesKey, idsKey, key) {
      var names = [];
      var ids = [];
      this.form[key].forEach(function (item) {
        names.push(item.name);
        ids.push(item.id);
      });
      this.$set(this.form, namesKey, names);
      this.$set(this.form, idsKey, ids);
    },
    tagMatch: function tagMatch(s) {
      var reg = /#.*? |#.*/g;
      s = s.match(reg);
      return s;
    },
    //如果运营取消选中了 AI 分析的结果，要处理text_category_names和text_category_ids
    changeAssayValue: function changeAssayValue(tag) {
      var nameIndex = this.form.text_category_names.indexOf(tag.name);
      var idIndex = this.form.text_category_ids.indexOf(tag.id);
      if (nameIndex > -1) {
        this.form.text_category_names.splice(nameIndex, 1);
      }
      if (idIndex > -1) {
        this.form.text_category_ids.splice(idIndex, 1);
      }
    },
    save: function save(type) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _this10.saveUserInfo();
              _this10.deconstructionData("admin_category_names", "admin_category_ids", "adminCategoryList");
              _context0.n = 1;
              return _this10.$api.updateCommunity(_this10.form);
            case 1:
              _this10.getData();
              _this10.$message.success("保存成功");
              if (type != "audit") {
                // 操作上报
                _this10.$operationLog.push({
                  code: "save",
                  userId: _this10.userForm.id,
                  operationType: "community",
                  detailBatchNo: _this10.$route.query.id
                });
              }
            case 2:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    setCover: function setCover(url) {
      this.form.cover_url = url;
      // this.form.cover_type = 'image';
    },
    deleteImage: function deleteImage(index, img) {
      var _this11 = this;
      this.form.image_urls.splice(index, 1);
      if (img == this.form.cover_url) {
        this.$nextTick(function () {
          _this11.form.cover_url = _this11.form.image_urls[0];
        });
      }
    },
    deleteVideo: function deleteVideo() {
      this.form.video_url = "";
      this.form.cover_url = this.form.image_urls[0];
    },
    selectVideoPreview: function selectVideoPreview() {
      var video = document.getElementById("J_video");
      var currentTime = Math.floor(video.currentTime);
      this.form.cover_url = appendUrlParam(this.form.video_url, "vframe/jpg/offset/".concat(currentTime));
      this.form.video_cut_start_frame = currentTime;
      this.videoVisible = false;
    },
    //获取用户社区信息记录
    getUserPostLog: function getUserPostLog(user_id) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var _res$data2;
        var res;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              _this12.loadingLog = true;
              _context1.n = 1;
              return _this12.$api.getUserPostLog({
                user_id: user_id,
                page: 1,
                limit: 50
              });
            case 1:
              res = _context1.v;
              _this12.postLog = ((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.list) || [];
              _this12.loadingLog = false;
            case 2:
              return _context1.a(2);
          }
        }, _callee1);
      }))();
    },
    handleKeyDown: function handleKeyDown(event) {
      // Command+P (Mac) 或 Ctrl+P (Windows) 触发通过操作
      if ((event.metaKey || event.ctrlKey) && (event.key === 'p' || event.key === 'P')) {
        event.preventDefault(); // 阻止默认行为（打印页面）
        if (this.form.audit_status == 0 && this.$refs.passBtn) {
          this.audit(1, 0);
        }
      }
      // Command+K (Mac) 或 Ctrl+K (Windows) 触发通过操作
      if ((event.metaKey || event.ctrlKey) && (event.key === 'k' || event.key === 'K')) {
        event.preventDefault(); // 阻止默认行为（收藏网页）
        if (this.form.audit_status == 0 && this.$refs.rejectBtn) {
          this.$refs.rejectModal.show();
          this.$refs.rejectBtn.$el.scrollIntoView({});
        }
      }
      // 空格键触发下一个操作（仅当btnNextVisible为true时）
      if (event.key === ' ' && this.btnNextVisible && this.$refs.btnNext) {
        event.preventDefault(); // 阻止默认行为（滚动页面）
        this.$refs.btnNext.next();
      }
    }
  })
};